"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/conferencing`;
    }
    /**
     * Returns information on Free Conference Calling (FCC) feature
   * for a given extension.
   *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/conferencing
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: OrganizeConference
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the default conferencing number for the current extension.
   * The number can be selected from conferencing numbers of the current extension.
   * Updates the setting, allowing participants join the conference before host.
   *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/conferencing
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: OrganizeConference
     */
    async put(updateConferencingInfoRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), updateConferencingInfoRequest, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map